import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/map-stroke.png'
import _imports_1 from '@/assets/images/map.png'


const _withScopeId = n => (_pushScopeId("data-v-a3559f3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map" }
const _hoisted_2 = {
  key: 0,
  class: "map-img-stroke",
  src: _imports_0,
  alt: ""
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "map-img",
  src: _imports_1,
  alt: ""
}, null, -1))

import { useGameState } from '@/services/composition';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const state = useGameState()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "long-fade",
      appear: ""
    }, {
      default: _withCtx(() => [
        (_unref(state).matches('tuto.companion.plan'))
          ? (_openBlock(), _createElementBlock("img", _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _hoisted_3
  ]))
}
}

})